import SlideFrame from './SlideFrame';

interface Props {
  title: string; sub: string;
  not_t: string; not: string[];
  triggers_t: string; triggers: string[];
}

export default function DarkHero({ title, sub, not_t, not: notItems, triggers_t, triggers }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="dark-hero">
        <div className="dark-hero-grid">
          <div className="dark-hero-panel dark-hero--not">
            <div className="dark-hero-t">{not_t}</div>
            <ul className="dark-hero-list">
              {notItems.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
          <div className="dark-hero-panel">
            <div className="dark-hero-t" style={{ color: '#FDE68A' }}>{triggers_t}</div>
            <ul className="dark-hero-list">
              {triggers.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
